/**
 * Phase 54.23.9 — Pin/unpin the current page as a sidebar favorite.
 * Tiny icon-only toggle that lives inside PageHeader (and the
 * custom BackupPage header). Auto-hides on any pathname not in
 * PAGE_INDEX so it never appears on modal, print, or POS-detail
 * routes.
 */
import React from "react";
import { useLocation } from "react-router-dom";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { useFavoriteToggle } from "./usmSidebarPrefs";

export default function FavoriteStar({ className = "" }) {
  const location = useLocation();
  const { isFav, toggle, isKnown } = useFavoriteToggle(location.pathname);

  if (!isKnown) return null;

  const onClick = () => {
    const r = toggle();
    if (!r.ok && r.reason === "cap-reached") {
      toast.error(`En fazla ${r.cap} favori sayfa ekleyebilirsin`);
      return;
    }
    if (r.added) toast.success("Favorilere eklendi");
    else if (r.ok) toast.success("Favorilerden kaldırıldı");
  };

  return (
    <button
      type="button"
      data-testid="page-favorite-toggle"
      aria-pressed={isFav}
      onClick={onClick}
      title={isFav ? "Favorilerden kaldır" : "Favorilere ekle"}
      className={
        "shrink-0 w-9 h-9 inline-flex items-center justify-center rounded transition-colors " +
        (isFav
          ? "text-[#C8A96A] hover:bg-[#FAFAF9]"
          : "text-[#A1A1AA] hover:text-[#C8A96A] hover:bg-[#FAFAF9]") +
        (className ? " " + className : "")
      }
    >
      <Star size={17} strokeWidth={1.75} fill={isFav ? "#C8A96A" : "none"} />
    </button>
  );
}
